import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { saveReturnPath } from "../utils/postLoginPath";
import PageLoader from "../components/PageLoader";

const PrivateRoute = () => {
  const location = useLocation();

  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  const shouldRedirect =
    authStatus !== "authenticated" && authStatus !== "configuring";

  // Router state is lost if a failed API call (401) reloads the page before
  // the user signs in, so also keep the requested page for this tab.
  useEffect(() => {
    if (shouldRedirect) saveReturnPath(location);
  }, [shouldRedirect, location]);

  if (shouldRedirect) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Amplify is still restoring the session. Rendering the page now would fire
  // its API calls before auth is known; if the user is signed out those 401s
  // trigger a forced sign-out reload for every request.
  if (authStatus === "configuring") {
    return <PageLoader />;
  }

  return <Outlet />;
};

export default PrivateRoute;
